

















import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "content-header-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderControl.vue")
  }
})
export default class ContentHeaderFirstStepsControl extends Vue {
  // Computed
  public get isOpen() {
    return this.$store.getters["ui/userflow/resourceCenterIsOpen"];
  }
  // Methods
  public toggleResourceCenter() {
    return this.$store.dispatch("ui/userflow/toggleResourceCenter");
  }
}
